module.exports = "<pre><code class=\"lang-js\">// State\nconst state = { steps: 3, step: undefined }\n\n// Getters...\n// Mutations...\n\n// Export\n</code></pre>\n";


//////////////////
// WEBPACK FOOTER
// ./src/markdowns/vuex/meta.md
// module id = xC3h
// module chunks = 1